import axios from 'axios';
import type { ICompany } from '../types';

export const getCompany = async () => {
  return axios.get<ICompany>('/company');
};

export const updateCompany = (company: ICompany) => {
  return axios.put<ICompany>(`/company/${company.id}`, company);
};

export const uploadCompanyLogo = (companyId: string, file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`/company/logo/${companyId}`, formData);
};

export const deleteCompanyLogo = (companyId: string) => {
  return axios.delete(`/company/logo/${companyId}`);
};
